import { keys } from '@/injection-keys'

// Get the disabled state from 1. a parent state or 2. a direct attribute
export function useDisabled() {
  const attrs = useAttrs()

  return computed(
    () =>
      (unref(inject(keys.disabled, undefined)) || 'disabled' in attrs) && attrs.disabled !== false,
  )
}
